import React, { Component, Fragment } from 'react'
import Reboot from 'material-ui/Reboot'
import { withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import { LinearProgress } from 'material-ui/Progress'
import Typography from 'material-ui/Typography'

import Dialog, {
  DialogContent,
  DialogActions
} from 'material-ui/Dialog'

import {Cropper} from 'react-image-cropper'

import mergeImages from 'merge-images'


class App extends Component {
 constructor () {
   super()
   this.state = {
     isMobileSize:false
   }
   this.checkWindowSize = this.checkWindowSize.bind(this)
 }

 checkWindowSize () {
   const mobileWidth = 768
   this.setState({isMobileSize:window.outerWidth < mobileWidth})
 }

 componentWillMount () {
  this.checkWindowSize()
  window.addEventListener('orientationchange',this.checkWindowSize)
  window.addEventListener('resize',this.checkWindowSize)
 }

 render() {
  const { classes } = this.props

  return (
   <Fragment>

    {!this.state.isMobileSize &&
     <div className={classes.desktop}>
      <Reboot />
      <div className={classes.desktopSmartphone}>
       <img src={process.env.PUBLIC_URL + "/images/smartphoneFrame.png"} alt="smartphoneframe" className={classes.desktopSmartphoneImg} />
      </div>
      <div className={classes.content}>
       <Content classes={classes} />
      </div>
     </div>
    }

    {this.state.isMobileSize &&
     <section className={classNames(classes.content,classes.contentShift)}>
      <Content classes={classes} />
     </section>
    }

   </Fragment>
  )
 }
}

class CropScreenshotDialog extends React.Component {
  constructor () {
    super()
    this.cutSound = new Audio('/avatars/audio/cut.mp3')
  }

  render () {
    const { mergedImage } = this.props
    return (
      <Dialog
       open={this.props.open}
       onClose={this.props.handleClose}
      >
      <DialogActions>
        <Button size="small" onClick={this.props.downloadImage.bind(this,mergedImage)}>
         <Icon>file_download</Icon>
         Original herunterladen

        </Button>
        <Button onClick={this.crop} size="small" autoFocus>
         <Icon>content_cut</Icon>
         zuschneiden
        </Button>
       </DialogActions>
       <DialogContent>
       <Cropper
        src={mergedImage}
        ref={ ref => { this.cropper = ref }}
        onClick={this.crop}
        fixedRatio={false}
        originX={80}
        originY={150}
       />
       </DialogContent>
      </Dialog>
    )
  }


  crop = () => {
   const cropped = this.cropper.crop()
   this.props.downloadImage(cropped)
   this.cutSound.play()
  }
}


class Content extends Component {
 constructor () {
   super()

   this.GENDER_MALE = 'MALE'
   this.GENDER_FEMALE = 'FEMALE'

   this.ACTION_PREV = 'prev'
   this.ACTION_NEXT = 'next'

   this.cameraFlashSounds = [
     new Audio('/avatars/audio/camera-0.mp3'),
     new Audio('/avatars/audio/camera-1.mp3')
   ]

   this.eraseSound = new Audio('/avatars/audio/erase.mp3')

   this.MALE = {}
   this.MALE.itemSlots = [
     {name:'SPECIAL',count:3},
     {name:'ACCESSOIRES',count:32},
     {name:'BEARDS',count:9},
     {name:'EYEBROWES',count:13},
     {name:'EYES',count:16},
     {name:'HAIR',count:21},
     {name:'HATS',count:21},
     {name:'LHAND',count:4},
     {name:'MOUTH',count:21},
     {name:'PANTS',count:29},
     {name:'RHAND',count:4},
     {name:'SHIRTS',count:30},
     {name:'SHOES',count:21}
   ]

   this.FEMALE = {}
   this.FEMALE.itemSlots = [
     {name:'SPECIAL',count:3},
     {name:'ACCESSOIRES',count:56},
     {name:'EYEBROWES',count:12},
     {name:'EYES',count:68},
     {name:'HAIRBACK',count:23},
     {name:'HAIRFRONT',count:15},
     {name:'HATS',count:15},
     {name:'LHAND',count:21},
     {name:'MOUTH',count:35},
     {name:'PANTS',count:33},
     {name:'RHAND',count:21},
     {name:'SHIRTS',count:41},
     {name:'SHOES',count:30}
   ]

   this.state = {
     openCropDialog:false,
     mergedImage:"",
     isTakingScreenshot:false,
     currentItemSlot:null,
     currentAccessoire:0,
     showNextAndPrev:false,
     gender:this.GENDER_FEMALE,
     avatar:{
       special:-1,
       accessoires:0,
       beards:0,
       eyebrowes:0,
       eyes:0,
       hair:0,
       hairfront:0,
       hairback:0,
       hats:0,
       lhand:0,
       mouth:0,
       pants:0,
       rhand:0,
       shirts:0,
       shoes:0
     }
   }
 }

 componentWillMount () {
   this.randomize()
 }

 render () {
   const { classes } = this.props
   return (
     <Fragment>

      {this.state.isTakingScreenshot &&
       <Fragment>
        <div className={classNames(classes.flash,"camera-flash")} />
        <LinearProgress color="secondary" className={classes.isTakingScreenshotProgress} />
       </Fragment>
      }

      <Avatar
       classes={classes}
       gender={this.state.gender}
       avatar={this.state.avatar}
       makeScreenshot={this.makeScreenshot}
      />

      <Gender
       classes={classes}
       gender={this.state.gender}
       switchGender={this.switchGender}
      />

      <Save
       classes={classes}
       save={this.save}
      />

      {this.state.showNextAndPrev &&
       <Fragment>
        <Next classes={classes} next={this.nextItem} />
        <Prev classes={classes} prev={this.prevItem} />
       </Fragment>
      }

      <Customize
       classes={classes}
       gender={this.state.gender}
       setItem={this.setItem}
       deleteItem={this.deleteItem}
       action={this.ACTION_NEXT}
       maleSlots={this.MALE.itemSlots}
       femaleSlots={this.FEMALE.itemSlots}
      />

      <CropScreenshotDialog
       open={this.state.openCropDialog}
       handleClose={this.handleCloseCropDialog}
       mergedImage={this.state.mergedImage}
       downloadImage={this.downloadScreenshot}
      />

     </Fragment>
   )
 }

 handleOpenCropDialog = () => {
   this.setState({openCropDialog:true})
 }

 handleCloseCropDialog = () => {
   this.setState({openCropDialog:false})
 }

 downloadScreenshot = (base64) => {
  const link = document.createElement("a"),
        filename = 'avatar_' + new Date().toUTCString() + '.png'

  link.setAttribute("href", base64)
  link.setAttribute("download", filename)
  link.click()
 }

 cameraFlash = (state) => {
  if (state) {
   this.cameraFlashSounds[Math.random() > 0.5 ? 1 : 0].play()
  }

  this.setState({isTakingScreenshot:state})
 }

 save = () => {
   this.cameraFlash(true)
   this.mergeImages(base64 => {
     //this.downloadScreenshot(base64)
     this.setState({isTakingScreenshot:false,mergedImage:base64},() => {
       this.handleOpenCropDialog()
     })
   })
 }

 mergeImages = (cb) => {
   const { avatar,gender } = this.state
   const quality = '/'

   const head = require('./layers/'+gender.toLowerCase()+'/head/0.png')
   const body = require('./layers/'+gender.toLowerCase()+'/body/0.png')
   let beards = null, hair = null, hairfront = null, hairback = null, accessoires = null,
       eyebrowes = null, eyes = null, hats = null, lhand = null, mouth = null, pants = null,
       rhand = null, shirts = null, shoes = null, special = null,
       isMale = gender === this.GENDER_MALE, isFemale = gender === this.GENDER_FEMALE

   let avatarToDraw = []

   if (avatar.accessoires !== -1) accessoires = require('./layers/'+gender.toLowerCase()+'/accessoires'+quality+avatar.accessoires+'.png')
   if (avatar.eyebrowes !== -1) eyebrowes = require('./layers/'+gender.toLowerCase()+'/eyebrowes'+quality+avatar.eyebrowes+'.png')
   if (avatar.eyes !== -1) eyes = require('./layers/'+gender.toLowerCase()+'/eyes'+quality+avatar.eyes+'.png')
   if (avatar.hats !== -1) hats = require('./layers/'+gender.toLowerCase()+'/hats'+quality+avatar.hats+'.png')
   if (avatar.lhand !== -1) lhand = require('./layers/'+gender.toLowerCase()+'/lhand'+quality+avatar.lhand+'.png')
   if (avatar.mouth !== -1) mouth = require('./layers/'+gender.toLowerCase()+'/mouth'+quality+avatar.mouth+'.png')
   if (avatar.pants !== -1) pants = require('./layers/'+gender.toLowerCase()+'/pants'+quality+avatar.pants+'.png')
   if (avatar.rhand !== -1) rhand = require('./layers/'+gender.toLowerCase()+'/rhand'+quality+avatar.rhand+'.png')
   if (avatar.shirts !== -1) shirts = require('./layers/'+gender.toLowerCase()+'/shirts'+quality+avatar.shirts+'.png')
   if (avatar.shoes !== -1) shoes = require('./layers/'+gender.toLowerCase()+'/shoes'+quality+avatar.shoes+'.png')
   if (avatar.special !== -1) special = require('./layers/'+gender.toLowerCase()+'/special'+quality+avatar.special+'.png')

   if (isMale) {
     if (avatar.beards !== -1) beards = require('./layers/'+gender.toLowerCase()+'/beards'+quality+avatar.beards+'.png')
     if (avatar.hair !== -1) hair = require('./layers/'+gender.toLowerCase()+'/hair'+quality+avatar.hair+'.png')

     // keep this order
     if (special) avatarToDraw.push(special)
     avatarToDraw.push(body)
     if (lhand) avatarToDraw.push(lhand)
     if (rhand) avatarToDraw.push(rhand)
     if (pants) avatarToDraw.push(pants)
     if (shoes) avatarToDraw.push(shoes)
     if (shirts) avatarToDraw.push(shirts)
     avatarToDraw.push(head)
     if (eyes) avatarToDraw.push(eyes)
     if (eyebrowes) avatarToDraw.push(eyebrowes)
     if (hair) avatarToDraw.push(hair)
     if (hats) avatarToDraw.push(hats)
     if (beards) avatarToDraw.push(beards)
     if (mouth) avatarToDraw.push(mouth)
     if (accessoires) avatarToDraw.push(accessoires)
   }

   else if (isFemale) {
     if (avatar.hairfront !== -1) hairfront = require('./layers/'+gender.toLowerCase()+'/hairfront'+quality+avatar.hairfront+'.png')
     if (avatar.hairback !== -1) hairback = require('./layers/'+gender.toLowerCase()+'/hairback'+quality+avatar.hairback+'.png')

     // keep this order
     if (special) avatarToDraw.push(special)
     if (hairback) avatarToDraw.push(hairback)
     avatarToDraw.push(body)
     if (lhand) avatarToDraw.push(lhand)
     if (rhand) avatarToDraw.push(rhand)
     if (pants) avatarToDraw.push(pants)
     if (shoes) avatarToDraw.push(shoes)
     if (shirts) avatarToDraw.push(shirts)
     avatarToDraw.push(head)
     if (eyes) avatarToDraw.push(eyes)
     if (eyebrowes) avatarToDraw.push(eyebrowes)
     if (hairfront) avatarToDraw.push(hairfront)
     if (hats) avatarToDraw.push(hats)
     if (mouth) avatarToDraw.push(mouth)
     if (accessoires) avatarToDraw.push(accessoires)
   }

   mergeImages(avatarToDraw).then(base64 => { cb(base64) })
 }

 switchGender = () => {
   this.checkAvatarBounds( () => {
     if (this.state.gender === this.GENDER_MALE) {
       this.setState({gender:this.GENDER_FEMALE})
     } else {
       this.setState({gender:this.GENDER_MALE})
     }
   })
 }

 checkAvatarBounds = (cb) => {
  const boundaries = this.state.gender === this.GENDER_MALE ? this.FEMALE.itemSlots : this.MALE.itemSlots
  let avatar = JSON.parse(JSON.stringify(this.state.avatar))
  let outOfBound = false

  for (let key in boundaries) {
    const bodyPart = boundaries[key].name.toLowerCase()
    if (avatar[bodyPart] >= boundaries[key].count) {
      avatar[bodyPart] = boundaries[key].count - 1
      outOfBound = true
    }
  }

  if (outOfBound) {
   this.setState({avatar:avatar}, cb)
  } else cb()

 }

 nextItem = (itemSlot) => {
  this.setItem(this.state.currentItemSlot,this.ACTION_NEXT)
 }

 prevItem = (itemSlot) => {
  this.setItem(this.state.currentItemSlot,this.ACTION_PREV)
 }

 setItem = (itemSlot,action) => {
   let avatar = JSON.parse(JSON.stringify(this.state.avatar))
   const bodyPart = itemSlot.name.toLowerCase()
   let item = null

   if (action === this.ACTION_NEXT) {
    item = this.state.avatar[bodyPart] + 1
    if (item >= itemSlot.count) {
      item = 0
    }
   }
   else if (action === this.ACTION_PREV) {
     item = this.state.avatar[bodyPart] - 1
     if (item < 0) {
       item = itemSlot.count - 1
     }
   }
   avatar[bodyPart] = item

   this.setState({avatar:avatar,currentItemSlot:itemSlot,showNextAndPrev:true})
 }

 randomize = () => {
   const gender = Math.random() > 0.5 ? this.GENDER_MALE : this.GENDER_FEMALE
   const boundaries = gender === this.GENDER_MALE ? this.MALE.itemSlots : this.FEMALE.itemSlots
   const avatar = JSON.parse(JSON.stringify(this.state.avatar))

   for (let key in boundaries) {
     const bodyPart = boundaries[key].name.toLowerCase()
     // 10 % chance to set special part (not every avatar should randomized have one)
     if (bodyPart === 'special') {
       const r = Math.random() > 0.9
       if (!r) {
         continue
       }
     }
     avatar[bodyPart] = Math.floor(Math.random() * boundaries[key].count)
   }

   this.setState({gender:gender,avatar:avatar})
 }

 deleteItem = (itemSlot) => {
   this.eraseSound.play()

   let avatar = JSON.parse(JSON.stringify(this.state.avatar))
   const bodyPart = itemSlot.name.toLowerCase()
   avatar[bodyPart] = -1

   this.setState({avatar:avatar,currentItemSlot:null,showNextAndPrev:false})
 }

}

class Avatar extends Component {
  render () {
    const { classes,gender,avatar } = this.props

    const quality = '/400/'

    const head = require('./layers/'+gender.toLowerCase()+'/head/0_400.png')
    const shadow = require('./layers/'+gender.toLowerCase()+'/shadow/0_400.png')
    const body = require('./layers/'+gender.toLowerCase()+'/body/0_400.png')

    let beards = null, hair = null, hairfront = null, hairback = null, accessoires = null,
        eyebrowes = null, eyes = null, hats = null, lhand = null, mouth = null, pants = null,
        rhand = null, shirts = null, shoes = null, special = null,
        isMale = gender === 'MALE', isFemale = gender === 'FEMALE'

    if (isMale) {
      if (avatar.beards !== -1) beards = require('./layers/'+gender.toLowerCase()+'/beards'+quality+avatar.beards+'.png')
      if (avatar.hair !== -1) hair = require('./layers/'+gender.toLowerCase()+'/hair'+quality+avatar.hair+'.png')
    }

    else if (isFemale) {
      if (avatar.hairfront !== -1) hairfront = require('./layers/'+gender.toLowerCase()+'/hairfront'+quality+avatar.hairfront+'.png')
      if (avatar.hairback !== -1) hairback = require('./layers/'+gender.toLowerCase()+'/hairback'+quality+avatar.hairback+'.png')
    }

    if (avatar.accessoires !== -1) accessoires = require('./layers/'+gender.toLowerCase()+'/accessoires'+quality+avatar.accessoires+'.png')
    if (avatar.eyebrowes !== -1) eyebrowes = require('./layers/'+gender.toLowerCase()+'/eyebrowes'+quality+avatar.eyebrowes+'.png')
    if (avatar.eyes !== -1) eyes = require('./layers/'+gender.toLowerCase()+'/eyes'+quality+avatar.eyes+'.png')
    if (avatar.hats !== -1) hats = require('./layers/'+gender.toLowerCase()+'/hats'+quality+avatar.hats+'.png')
    if (avatar.lhand !== -1) lhand = require('./layers/'+gender.toLowerCase()+'/lhand'+quality+avatar.lhand+'.png')
    if (avatar.mouth !== -1) mouth = require('./layers/'+gender.toLowerCase()+'/mouth'+quality+avatar.mouth+'.png')
    if (avatar.pants !== -1) pants = require('./layers/'+gender.toLowerCase()+'/pants'+quality+avatar.pants+'.png')
    if (avatar.rhand !== -1) rhand = require('./layers/'+gender.toLowerCase()+'/rhand'+quality+avatar.rhand+'.png')
    if (avatar.shirts !== -1) shirts = require('./layers/'+gender.toLowerCase()+'/shirts'+quality+avatar.shirts+'.png')
    if (avatar.shoes !== -1) shoes = require('./layers/'+gender.toLowerCase()+'/shoes'+quality+avatar.shoes+'.png')
    if (avatar.special !== -1) special = require('./layers/'+gender.toLowerCase()+'/special'+quality+avatar.special+'.png')

    return (
      <div className={classNames(classes.avatarContainer,classes['avatarContainer'+gender])}>
       <div className={classes.avatar}>

        <div className={classes.avatarItem} style={{backgroundImage:'url('+shadow+')'}}/>
        {special && <div className={classes.avatarItem} style={{backgroundImage:'url('+special+')'}}/> }
        {hairback && <div className={classes.avatarItem} style={{backgroundImage:'url('+hairback+')'}}/> }
        <div className={classes.avatarItem} style={{backgroundImage:'url('+body+')'}}/>
        {lhand && <div className={classes.avatarItem} style={{backgroundImage:'url('+lhand+')'}}/>}
        {rhand && <div className={classes.avatarItem} style={{backgroundImage:'url('+rhand+')'}}/>}
        {pants && <div className={classes.avatarItem} style={{backgroundImage:'url('+pants+')'}}/>}
        {shoes && <div className={classes.avatarItem} style={{backgroundImage:'url('+shoes+')'}}/>}
        {shirts && <div className={classes.avatarItem} style={{backgroundImage:'url('+shirts+')'}}/>}
        <div className={classes.avatarItem} style={{backgroundImage:'url('+head+')'}}/>
        {eyes && <div className={classes.avatarItem} style={{backgroundImage:'url('+eyes+')'}}/>}
        {eyebrowes && <div className={classes.avatarItem} style={{backgroundImage:'url('+eyebrowes+')'}}/>}
        {hair && <div className={classes.avatarItem} style={{backgroundImage:'url('+hair+')'}}/>}
        {hairfront && <div className={classes.avatarItem} style={{backgroundImage:'url('+hairfront+')'}}/>}
        {hats && <div className={classes.avatarItem} style={{backgroundImage:'url('+hats+')'}}/>}
        {beards && <div className={classes.avatarItem} style={{backgroundImage:'url('+beards+')'}}/>}
        {mouth && <div className={classes.avatarItem} style={{backgroundImage:'url('+mouth+')'}}/>}
        {accessoires && <div className={classes.avatarItem} style={{backgroundImage:'url('+accessoires+')'}}/>}

       </div>
      </div>
    )
  }
}

class Gender extends Component {
  render () {
    const { classes, gender } = this.props
    return (
      <IconButton className={classes.switchGenderButton} onClick={this.props.switchGender}>
       <img src={require('./layers/'+gender.toLowerCase()+'.png')} alt="gender" className={classes.switchGenderImg} />
      </IconButton>
    )
  }
}

class Save extends Component {
  render () {
    const { classes } = this.props
    return (
      <IconButton className={classes.saveButton} onClick={this.props.save}>
       <img src={require('./layers/save.png')} alt="save" className={classes.saveImg} />
      </IconButton>
    )
  }
}

class Prev extends Component {
  render () {
    const { classes } = this.props
    return (
      <IconButton className={classes.prevButton} onClick={this.props.prev}>
       <img src={require('./layers/prev.png')} alt="gender" className={classes.prevImg} />
      </IconButton>
    )
  }
}

class Next extends Component {
  render () {
    const { classes } = this.props
    return (
      <IconButton className={classes.nextButton} onClick={this.props.next}>
       <img src={require('./layers/next.png')} alt="gender" className={classes.nextImg} />
      </IconButton>
    )
  }
}


class Customize extends Component {
  constructor () {
    super()
    this.holdToDeleteTime = 800
    this.state = {
      longPressed:false,
      showHint:true
    }
  }

  render () {
    const { classes,gender,action,maleSlots,femaleSlots } = this.props
    const itemSlots = gender === 'MALE' ? maleSlots : femaleSlots


    return (
      <div className={classNames(classes.customizeList)}>

       {itemSlots.map( (itemSlot,index) => {
        const image = require('./layers/'+gender.toLowerCase()+'/'+itemSlot.name.toLowerCase()+'/400/0.png')
        const isSpecialButton = itemSlot.name === 'SPECIAL'

        return <Button
         mini
         variant="fab"
         key={"item-slot-"+index}
         className={classNames(
           classes.customizeItem,
           classes[gender+'_'+itemSlot.name],
           (isSpecialButton ? classes.specialItemButton : '')
         )}
         style={{backgroundImage:'url('+image+')'}}

         onMouseDown={this.handleStartEvent.bind(this,itemSlot)}
         onTouchStart={this.handleStartEvent.bind(this,itemSlot)}

         onMouseUp={this.handleEndEvent.bind(this,itemSlot,action)}
         onTouchEnd={this.handleEndEvent.bind(this,itemSlot,action)}
        >
          <i />
        </Button>
        })
       }

       {this.state.showHint &&
         <div className={classes.holdToDelete} onClick={this.removeHint}>
          <img src={require('./layers/holdToDelete.png')} className={classes.holdToDeleteImg} alt=""/>
          <div className={classes.holdToDeleteText}>
           <Typography type="caption"> Lange drücken um einen Gegenstand zu entfernen </Typography>
          </div>
         </div>
       }


      </div>
    )
  }

  removeHint = () => {
    this.setState({showHint:false})
  }

  handleStartEvent = (itemSlot) => {
   this.longPressTimer = setTimeout(() => {

    this.setState({longPressed:true}, () => {
     this.props.deleteItem(itemSlot)
    })

   },this.holdToDeleteTime)
  }

  handleEndEvent = (itemSlot,action,e) => {
    e.stopPropagation()
    e.preventDefault()
    
    clearTimeout(this.longPressTimer)

    if (!this.state.longPressed) {
     this.props.setItem(itemSlot,action)
    }
    this.setState({longPressed:false})
  }
}



const styles = {
 holdToDelete:{
  position:'absolute',
  bottom:-21,
  left:-104,
  width:'100%'
 },
 holdToDeleteImg:{
   width:'40%'
 },
 holdToDeleteText:{
  position: 'absolute',
  bottom: 20,
  left: 180,
  background: 'rgba(255,255,255,0.8)'
 },
 desktop :{
  'background-image':'url('+require('./layers/wooden_desktop.png')+')',
  width:'100%',
  height:'100%',
  'background-repeat':'no-repeat',
  'background-position':'center center',
 },
 desktopSmartphone:{
   position:'absolute',
   'z-index': 10,
   bottom: -50,
   width: 660,
   margin:'0 auto',
   left: 0,
   right: 0,
   'pointer-events': 'none'
 },
 desktopSmartphoneImg:{
   width:'100%'
 },
 content:{
  position: 'absolute',
  'z-index': 5,
  left: 32,
  right: 0,
  bottom: 73,
  margin:'0 auto',
  width: 344,
  height: 526,
  border: 0,
  overflow:'hidden'
 },
 contentShift:{
   left:0,
   bottom:0
 },
 flash:{
   position:'absolute',
   'z-index':100,
   top:0,
   left:0,
   width:'100%',
   height:'100%',
   background:'#fff',
 },
 isTakingScreenshotProgress:{
   position:'absolute',
   top:0,
   left:0,
   width:'100%',
   'z-index':110
 },
 customizeList:{
   position:'absolute',
   width:'100%',
   bottom:10,
   left:0,
   height:'15%',
   'text-align':'center',
   'max-height':200,
   'min-height':100,
 },
 customizeItem:{
  'background-repeat':'no-repeat',
  margin:5,
  'background-color':'#fff'
 },
 specialItemButton:{
   position:'absolute',
   left:1,
   top:-44
 },
 avatarContainer:{
   position:'absolute',
   width:'100%',
   left:0,
   height:'100%',
 },
 avatarContainerMALE:{
   bottom:-40
 },
 avatarContainerFEMALE:{
   bottom:-65
 },
 avatar:{
   position:'relative',
   width:'100%',
   height:'100%'
 },
 avatarItem:{
  position:'absolute',
  left:0,
  bottom:'10%',
  width:'100%',
  height:'120%',
  'background-repeat':'no-repeat',
  'background-size':'100%'
},
 height100p:{
   height:"100%"
 },
 switchGenderButton:{
   position:'absolute',
   top:10,
   right:10,
   width:36,
 },
 switchGenderImg:{
   width:'100%'
 },
 saveButton:{
   position:'absolute',
   top:10,
   left:10,
   width:36,
 },
 saveImg:{
   width:'100%'
 },
 nextButton:{
   position:'absolute',
   bottom:'30%',
   right:10,
   width:36
 },
 nextImg:{
   width:'100%'
 },
 prevButton:{
   position:'absolute',
   bottom:'30%',
   left:10,
   width:36
 },
 prevImg:{
   width:'100%'
 },
 closeDrawerImg:{
   width:'100%'
 },
 itemListPaper:{
  'flex-direction':'row',
  background:'rgba(0,0,0,0)'
 },
 itemListSlotContainer:{
   width:'100%',
   'text-align':'center'
 },
 itemListSlot:{
   width:'12%',
   height:130,
   'background-repeat':'no-repeat',
   'background-position':'center',
   'background-size':'contain',
   margin:5,
   display:'inline-block',
   cursor:'pointer'
 },
 drawerClose:{
  position:'fixed',
  right:10,
  top:10,
  width:48,
  height:48
 },
 MALE_SPECIAL:{
   'background-size':'100%',
   'background-position':'50% 79%'
 },
 MALE_ACCESSOIRES:{
   'background-size':'200%',
   'background-position':'50% 48%'
 },
 MALE_BEARDS:{
  'background-size':'350%',
  'background-position':'50% 59%'
 },
 MALE_EYEBROWES:{
   'background-size':'260%',
   'background-position':'50% 47%'
 },
 MALE_EYES:{
   'background-size':'290%',
   'background-position':'50% 53%'
 },
 MALE_HAIR:{
   'background-size':'160%',
   'background-position':'50% 40%'
 },
 MALE_HATS:{
   'background-size':'130%',
   'background-position':'50% 30%'
 },
 MALE_LHAND:{
   'background-size':'300%',
   'background-position':'28% 74%'
 },
 MALE_MOUTH:{
   'background-size':'370%',
   'background-position':'50% 61%'
 },
 MALE_PANTS:{
   'background-size':'300%',
   'background-position':'50% 88%'
 },
 MALE_RHAND:{
   'background-size':'300%',
   'background-position':'78% 71%'
 },
 MALE_SHIRTS:{
   'background-size':'350%',
   'background-position':'50% 76%'
 },
 MALE_SHOES:{
   'background-size':'255%',
   'background-position':'50% 103%'
 },
 FEMALE_SPECIAL:{
   'background-size':'100%',
   'background-position':'50% 79%'
 },
 FEMALE_ACCESSOIRES:{
   'background-size':'280%',
   'background-position':'15% 95%'
 },
 FEMALE_EYEBROWES:{
   'background-size':'260%',
   'background-position':'50% 39%'
 },
 FEMALE_EYES:{
   'background-size':'260%',
   'background-position':'50% 46%'
 },
 FEMALE_HAIRBACK:{
   'background-size':'115%',
   'background-position':'50% 50%'
 },
 FEMALE_HAIRFRONT:{
  'background-size':'160%',
  'background-position':'50% 35%'
 },
 FEMALE_HATS:{
   'background-size':'130%',
   'background-position':'50% 30%'
 },
 FEMALE_LHAND:{
   'background-size':'300%',
   'background-position':'26% 65%'
 },
 FEMALE_MOUTH:{
   'background-size':'370%',
   'background-position':'51% 56%'
 },
 FEMALE_PANTS:{
   'background-size':'300%',
   'background-position':'51% 83%'
 },
 FEMALE_RHAND:{
   'background-size':'300%',
   'background-position':'78% 65%'
 },
 FEMALE_SHIRTS:{
   'background-size':'350%',
   'background-position':'51% 71%'
 },
 FEMALE_SHOES:{
   'background-size':'255%',
   'background-position':'50% 99%'
 }
}

App.propTypes = { classes: PropTypes.object.isRequired }

export default withStyles(styles)(App)



// WEBPACK FOOTER //
// ./src/App.js